import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { colors } from '@/plugins/vuelux/util/colors';
import { Ripple } from 'vuetify/es5/directives'
import 'vuetify/src/stylus/app.styl';
import '@fortawesome/fontawesome-free/css/all.css'
import '@/assets/custom-fonts/luxtag/css/luxtag.css';

const CUSTOM_ICONS = {
  'attachment': 'icon-attachment',
  'avatar': 'icon-avatar',
  'switchCamera': 'icon-camera',
  'commentOval': 'icon-comment-black-oval-bubble-shape',
  'list': 'icon-list',
  'path': 'icon-path',
  'pencil': 'icon-pencil',
  'verify': 'icon-verify',
  'transfer': 'icon-transfer',
  'transferSmall': 'icon-transfer-small',  
  'receive': 'icon-receive',
  'hamburger': 'icon-hamburger',
  'claim': 'icon-claim',
  'share': 'icon-share',
  'list-large': 'icon-large',
  'list-medium': 'icon-medium',
  'exclamation-mark': 'icon-exclamation-mark',
  'location': 'icon-location',
  'trash': 'icon-trash',
}

Vue.use(Vuetify, {
  iconfont: 'fa',
  icons: CUSTOM_ICONS,
  theme: {
    primary: colors.primary,
    secondary: colors.secondary,
    accent: colors.accent,
    error: colors.error,
    info: colors.info,
    success: colors.success,
    warning: colors.warning,
    lines: colors.lines,
    lightGrey: colors.lightGrey,
  },
  directives: {
    Ripple
  }
})
